// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Link = require("next/link").default;
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NotificationsAndAlertsUtils = require("../common/notifications/NotificationsAndAlertsUtils.bs.js");
let AgentMatchLogTextsBuyerNeed_aml_graphql = require("../../__generated__/AgentMatchLogTextsBuyerNeed_aml_graphql.bs.js");
let AgentMatchLogTextsRentalNeed_aml_graphql = require("../../__generated__/AgentMatchLogTextsRentalNeed_aml_graphql.bs.js");
let AgentMatchLogTextsRentalProperty_aml_graphql = require("../../__generated__/AgentMatchLogTextsRentalProperty_aml_graphql.bs.js");
let AgentMatchLogTextsForSaleProperty_aml_graphql = require("../../__generated__/AgentMatchLogTextsForSaleProperty_aml_graphql.bs.js");

let convertFragment = AgentMatchLogTextsForSaleProperty_aml_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment, fRef);
}

let AmlFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AgentMatchLogTexts$PropertyMatchText(props) {
  let __withLinks = props.withLinks;
  let withLinks = __withLinks !== undefined ? __withLinks : false;
  let aml = RescriptRelay_Fragment.useFragment(AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment, props.aml);
  let agentId = NotificationsAndAlertsUtils.AgentId.useForSaleAgentId(aml.source.agentV2.fragmentRefs);
  let shouldShowPropertyDetails = UserSession.useShouldShowPropertyDetails(agentId);
  let agentText = NotificationsAndAlertsUtils.AgentText.useForSaleAgentText(aml.source.agentV2.fragmentRefs);
  let match = aml.event;
  let verb;
  switch (match.__typename) {
    case "BroadcastPropertyCreatedAMLEvent" :
    case "QuietPropertyCreatedAMLEvent" :
      verb = "added";
      break;
    case "__unselected" :
      verb = "-";
      break;
    default:
      verb = "updated";
  }
  let match$1 = aml.event;
  let matches;
  switch (match$1.__typename) {
    case "BroadcastPropertyCreatedAMLEvent" :
      let match$2 = match$1.matches;
      matches = match$2 !== undefined ? ({
          TAG: "Matches",
          _0: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$2.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs)))
        }) : ({
          TAG: "Matches",
          _0: []
        });
      break;
    case "ForSalePropertyEditedAMLEvent" :
      matches = {
        TAG: "ExistingAndNew",
        new: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.newMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs))),
        existing: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.existingMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs)))
      };
      break;
    case "ForSalePropertyRebroadcastedAMLEvent" :
      matches = {
        TAG: "ExistingAndNew",
        new: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.newMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs))),
        existing: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.existingMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs)))
      };
      break;
    case "QuietPropertyBroadcastedAMLEvent" :
      matches = {
        TAG: "ExistingAndNew",
        new: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.newMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs))),
        existing: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.existingMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs)))
      };
      break;
    case "QuietPropertyCreatedAMLEvent" :
      let match$3 = match$1.matches;
      matches = match$3 !== undefined ? ({
          TAG: "Matches",
          _0: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$3.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs)))
        }) : ({
          TAG: "Matches",
          _0: []
        });
      break;
    case "__unselected" :
      matches = {
        TAG: "Matches",
        _0: []
      };
      break;
  }
  let matchesText;
  let exit = 0;
  let client;
  let matches$1;
  if (matches.TAG === "Matches") {
    let matches$2 = matches._0;
    if (matches$2.length !== 1) {
      matches$1 = matches$2;
      exit = 2;
    } else {
      let client$1 = matches$2[0];
      client = client$1;
      exit = 1;
    }
  } else {
    let matches$3 = matches.new;
    let exit$1 = 0;
    let len = matches$3.length;
    if (len !== 1) {
      if (len !== 0) {
        exit$1 = 3;
      } else {
        let matches$4 = matches.existing;
        if (matches$4.length !== 1) {
          matches$1 = matches$4;
          exit = 2;
        } else {
          let client$2 = matches$4[0];
          client = client$2;
          exit = 1;
        }
      }
    } else {
      let client$3 = matches$3[0];
      if (matches.existing.length !== 0) {
        exit$1 = 3;
      } else {
        client = client$3;
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (matches.existing.length !== 0) {
        let length = matches$3.length;
        let content = length.toString() + ` more of your buyers`;
        matchesText = withLinks ? JsxRuntime.jsx(Link, {
            href: `/match_log/` + aml.databaseId,
            children: content
          }) : content;
      } else {
        matches$1 = matches$3;
        exit = 2;
      }
    }
  }
  switch (exit) {
    case 1 :
      let clientName = NotificationsAndAlertsUtils.ClientLabel.getLabel(client, withLinks);
      matchesText = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          "your buyer ",
          clientName
        ]
      });
      break;
    case 2 :
      let length$1 = matches$1.length;
      let content$1 = length$1.toString() + ` of your buyers`;
      matchesText = withLinks ? JsxRuntime.jsx(Link, {
          href: `/match_log/` + aml.databaseId,
          children: content$1
        }) : content$1;
      break;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      shouldShowPropertyDetails ? (
          withLinks ? (
              agentId !== undefined ? JsxRuntime.jsx(Link, {
                  href: `/agents/` + agentId,
                  children: agentText
                }) : "A TAN agent"
            ) : agentText
        ) : "A TAN agent",
      ` ` + verb + ` a property that matches `,
      matchesText
    ]
  });
}

let PropertyMatchText = {
  AmlFragment: AmlFragment,
  make: AgentMatchLogTexts$PropertyMatchText
};

let convertFragment$1 = AgentMatchLogTextsRentalProperty_aml_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1, fRef);
}

let AmlFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function AgentMatchLogTexts$RentalPropertyMatchText(props) {
  let __withLinks = props.withLinks;
  let withLinks = __withLinks !== undefined ? __withLinks : false;
  let aml = RescriptRelay_Fragment.useFragment(AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1, props.aml);
  let agentId = NotificationsAndAlertsUtils.AgentId.useAgentId(aml.source.agent.fragmentRefs);
  let shouldShowPropertyDetails = UserSession.useShouldShowPropertyDetails(agentId);
  let agentText = NotificationsAndAlertsUtils.AgentText.useAgentText(aml.source.agent.fragmentRefs, withLinks);
  let match = aml.event;
  let verb;
  switch (match.__typename) {
    case "RentalPropertyCreatedAMLEvent" :
      verb = "added";
      break;
    case "RentalPropertyEditedAMLEvent" :
    case "RentalPropertyRebroadcastedAMLEvent" :
      verb = "updated";
      break;
    case "__unselected" :
      verb = "-";
      break;
  }
  let match$1 = aml.event;
  let mtches;
  switch (match$1.__typename) {
    case "RentalPropertyCreatedAMLEvent" :
      mtches = {
        TAG: "Matches",
        _0: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.matches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs)))
      };
      break;
    case "RentalPropertyEditedAMLEvent" :
      mtches = {
        TAG: "ExistingAndNew",
        new: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.newMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs))),
        existing: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.existingMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs)))
      };
      break;
    case "RentalPropertyRebroadcastedAMLEvent" :
      mtches = {
        TAG: "ExistingAndNew",
        new: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.newMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs))),
        existing: Stdlib_Array.keepSome(Stdlib_Array.keepSome(match$1.existingMatches.edges).map(e => Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs)))
      };
      break;
    case "__unselected" :
      mtches = {
        TAG: "Matches",
        _0: []
      };
      break;
  }
  let matchesText;
  let exit = 0;
  let client;
  let matches;
  if (mtches.TAG === "Matches") {
    let matches$1 = mtches._0;
    if (matches$1.length !== 1) {
      matches = matches$1;
      exit = 2;
    } else {
      let client$1 = matches$1[0];
      client = client$1;
      exit = 1;
    }
  } else {
    let matches$2 = mtches.new;
    let exit$1 = 0;
    let len = matches$2.length;
    if (len !== 1) {
      if (len !== 0) {
        exit$1 = 3;
      } else {
        let match$2 = mtches.existing;
        if (match$2.length !== 1) {
          exit$1 = 3;
        } else {
          let client$2 = match$2[0];
          client = client$2;
          exit = 1;
        }
      }
    } else {
      let client$3 = matches$2[0];
      if (mtches.existing.length !== 0) {
        exit$1 = 3;
      } else {
        client = client$3;
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (mtches.existing.length !== 0) {
        if (matches$2.length !== 0) {
          let length = matches$2.length;
          let content = length.toString() + ` more of your clients`;
          matchesText = withLinks ? JsxRuntime.jsx(Link, {
              href: `/match_log/` + aml.databaseId,
              children: content
            }) : content;
        } else {
          matches = mtches.existing;
          exit = 2;
        }
      } else {
        matches = matches$2;
        exit = 2;
      }
    }
  }
  switch (exit) {
    case 1 :
      let clientName = NotificationsAndAlertsUtils.ClientLabel.getLabel(client, withLinks);
      matchesText = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          "your client ",
          clientName
        ]
      });
      break;
    case 2 :
      let length$1 = matches.length;
      let content$1 = length$1.toString() + ` of your clients`;
      matchesText = withLinks ? JsxRuntime.jsx(Link, {
          href: `/match_log/` + aml.databaseId,
          children: content$1
        }) : content$1;
      break;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      shouldShowPropertyDetails ? (
          withLinks ? JsxRuntime.jsx(Link, {
              href: `/agents/` + agentId,
              children: agentText
            }) : agentText
        ) : "A TAN agent",
      ` ` + verb + ` a rental property that matches `,
      matchesText
    ]
  });
}

let RentalPropertyMatchText = {
  AmlFragment: AmlFragment$1,
  make: AgentMatchLogTexts$RentalPropertyMatchText
};

let convertFragment$2 = AgentMatchLogTextsBuyerNeed_aml_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2, fRef);
}

let AmlFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function AgentMatchLogTexts$BuyerNeedMatchText(props) {
  let __withLinks = props.withLinks;
  let withLinks = __withLinks !== undefined ? __withLinks : false;
  let aml = RescriptRelay_Fragment.useFragment(AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2, props.aml);
  let agentText = NotificationsAndAlertsUtils.AgentText.useAgentText(aml.source.agent.fragmentRefs, withLinks);
  let match = aml.event;
  let verb;
  switch (match.__typename) {
    case "BuyerNeedEditedAMLEvent" :
    case "QuietBuyerNeedBroadcastedAMLEvent" :
      verb = "updated";
      break;
    case "BroadcastBuyerNeedCreatedAMLEvent" :
    case "QuietBuyerNeedCreatedAMLEvent" :
      verb = agentText === "You" ? "have" : "has";
      break;
    case "__unselected" :
      verb = "-";
      break;
  }
  let match$1 = aml.event;
  let matches;
  switch (match$1.__typename) {
    case "BroadcastBuyerNeedCreatedAMLEvent" :
      matches = {
        TAG: "MatchesWithLocation",
        _0: Stdlib_Array.keepSome(match$1.matches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        }))
      };
      break;
    case "BuyerNeedEditedAMLEvent" :
      matches = {
        TAG: "ExistingAndNewWithLocation",
        new: Stdlib_Array.keepSome(match$1.newMatches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        })),
        existing: Stdlib_Array.keepSome(match$1.existingMatches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        }))
      };
      break;
    case "QuietBuyerNeedBroadcastedAMLEvent" :
      matches = {
        TAG: "ExistingAndNewWithLocation",
        new: Stdlib_Array.keepSome(match$1.newMatches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        })),
        existing: Stdlib_Array.keepSome(match$1.existingMatches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        }))
      };
      break;
    case "QuietBuyerNeedCreatedAMLEvent" :
      matches = {
        TAG: "MatchesWithLocation",
        _0: Stdlib_Array.keepSome(match$1.matches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        }))
      };
      break;
    case "__unselected" :
      matches = {
        TAG: "MatchesWithLocation",
        _0: []
      };
      break;
  }
  let matchesText;
  let exit = 0;
  let client;
  let location;
  let matches$1;
  if (matches.TAG === "MatchesWithLocation") {
    let matches$2 = matches._0;
    if (matches$2.length !== 1) {
      matches$1 = matches$2;
      exit = 2;
    } else {
      let match$2 = matches$2[0];
      client = match$2.client;
      location = match$2.location;
      exit = 1;
    }
  } else {
    let matches$3 = matches.new;
    let exit$1 = 0;
    let len = matches$3.length;
    if (len !== 1) {
      if (len !== 0) {
        exit$1 = 3;
      } else {
        let matches$4 = matches.existing;
        if (matches$4.length !== 1) {
          matches$1 = matches$4;
          exit = 2;
        } else {
          let match$3 = matches$4[0];
          client = match$3.client;
          location = match$3.location;
          exit = 1;
        }
      }
    } else {
      let match$4 = matches$3[0];
      if (matches.existing.length !== 0) {
        exit$1 = 3;
      } else {
        client = match$4.client;
        location = match$4.location;
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (matches.existing.length !== 0) {
        let content = matches$3.length.toString() + ` more of your sellers`;
        matchesText = withLinks ? JsxRuntime.jsx(Link, {
            href: `/match_log/` + aml.databaseId,
            children: content
          }) : content;
      } else {
        matches$1 = matches$3;
        exit = 2;
      }
    }
  }
  switch (exit) {
    case 1 :
      matchesText = Stdlib_Option.getOr(Stdlib_Option.map(client, c => NotificationsAndAlertsUtils.ClientLabel.getLabel(c, withLinks)), NotificationsAndAlertsUtils.PropertyLocationLabel.getLabel(location, withLinks));
      break;
    case 2 :
      let content$1 = matches$1.length.toString() + ` of your sellers`;
      matchesText = withLinks ? JsxRuntime.jsx(Link, {
          href: `/match_log/` + aml.databaseId,
          children: content$1
        }) : content$1;
      break;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      agentText,
      ` ` + verb + ` a buyer that matches `,
      matchesText
    ]
  });
}

let BuyerNeedMatchText = {
  AmlFragment: AmlFragment$2,
  make: AgentMatchLogTexts$BuyerNeedMatchText
};

let convertFragment$3 = AgentMatchLogTextsRentalNeed_aml_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3, fRef);
}

let AmlFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function AgentMatchLogTexts$RentalNeedMatchText(props) {
  let __mode = props.mode;
  let __withLinks = props.withLinks;
  let withLinks = __withLinks !== undefined ? __withLinks : false;
  let mode = __mode !== undefined ? __mode : "Notifications";
  let aml = RescriptRelay_Fragment.useFragment(AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3, props.aml);
  let agentText = NotificationsAndAlertsUtils.AgentText.useAgentText(aml.source.agent.fragmentRefs, withLinks);
  let match = aml.event;
  let verb;
  switch (match.__typename) {
    case "RentalNeedCreatedAMLEvent" :
      verb = agentText === "You" ? "have" : "has";
      break;
    case "RentalNeedEditedAMLEvent" :
      verb = mode === "Alerts" ? "has a renter" : "updated a client";
      break;
    case "__unselected" :
      verb = "-";
      break;
  }
  let match$1 = aml.event;
  let matches;
  switch (match$1.__typename) {
    case "RentalNeedCreatedAMLEvent" :
      matches = {
        TAG: "MatchesWithLocation",
        _0: Stdlib_Array.keepSome(match$1.matches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        }))
      };
      break;
    case "RentalNeedEditedAMLEvent" :
      matches = {
        TAG: "ExistingAndNewWithLocation",
        new: Stdlib_Array.keepSome(match$1.newMatches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        })),
        existing: Stdlib_Array.keepSome(match$1.existingMatches.edges).map(e => ({
          client: Stdlib_Option.map(e.node.source.client, v => v.fragmentRefs),
          location: e.node.source.fragmentRefs
        }))
      };
      break;
    case "__unselected" :
      matches = {
        TAG: "MatchesWithLocation",
        _0: []
      };
      break;
  }
  let matchesText;
  let exit = 0;
  let client;
  let location;
  let matches$1;
  if (matches.TAG === "MatchesWithLocation") {
    let matches$2 = matches._0;
    if (matches$2.length !== 1) {
      matches$1 = matches$2;
      exit = 2;
    } else {
      let match$2 = matches$2[0];
      client = match$2.client;
      location = match$2.location;
      exit = 1;
    }
  } else {
    let matches$3 = matches.new;
    let exit$1 = 0;
    let len = matches$3.length;
    if (len !== 1) {
      if (len !== 0) {
        exit$1 = 3;
      } else {
        let match$3 = matches.existing;
        if (match$3.length !== 1) {
          exit$1 = 3;
        } else {
          let match$4 = match$3[0];
          client = match$4.client;
          location = match$4.location;
          exit = 1;
        }
      }
    } else {
      let match$5 = matches$3[0];
      if (matches.existing.length !== 0) {
        exit$1 = 3;
      } else {
        client = match$5.client;
        location = match$5.location;
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (matches.existing.length !== 0) {
        if (matches$3.length !== 0) {
          let content = matches$3.length.toString() + ` more of your clients`;
          matchesText = withLinks ? JsxRuntime.jsx(Link, {
              href: `/match_log/` + aml.databaseId,
              children: content
            }) : content;
        } else {
          matches$1 = matches.existing;
          exit = 2;
        }
      } else {
        matches$1 = matches$3;
        exit = 2;
      }
    }
  }
  switch (exit) {
    case 1 :
      matchesText = Stdlib_Option.getOr(Stdlib_Option.map(client, c => NotificationsAndAlertsUtils.ClientLabel.getLabel(c, withLinks)), NotificationsAndAlertsUtils.PropertyLocationLabel.getLabel(location, withLinks));
      break;
    case 2 :
      let content$1 = matches$1.length.toString() + ` of your clients`;
      matchesText = withLinks ? JsxRuntime.jsx(Link, {
          href: `/match_log/` + aml.databaseId,
          children: content$1
        }) : content$1;
      break;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      agentText,
      ` ` + verb + ` that matches `,
      matchesText
    ]
  });
}

let RentalNeedMatchText = {
  AmlFragment: AmlFragment$3,
  make: AgentMatchLogTexts$RentalNeedMatchText
};

exports.PropertyMatchText = PropertyMatchText;
exports.RentalPropertyMatchText = RentalPropertyMatchText;
exports.BuyerNeedMatchText = BuyerNeedMatchText;
exports.RentalNeedMatchText = RentalNeedMatchText;
/* next/link Not a pure module */
